import styled from 'styled-components';

export const H1 = styled.h1`
  font-size: 2.5rem;
  font-weight: 600;
  color: #353d53;
  line-height: 1.3;
  margin: 0;

  @media (min-width: 76.8rem) {
    font-size: 3rem;
  }
`;

export const H2 = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  color: #353d53;
  line-height: 1.3;
  margin-left: 2rem;
  margin-bottom: 1.328rem;

  @media (min-width: 76.8rem) {
    margin-left: 3rem;
  }
`;

export const PolicyLetterContainer = styled.div`
  width: 100%;
  max-width: 90rem;
  margin: 3rem auto;
  font-family: Poppins;
  color: #7b7d8c;
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
`;

export const Main = styled.main`
  padding: 1rem;

  @media (min-width: 76.8rem) {
    padding: 3rem;
  }
`;

export const PolicyLetterHeader = styled.header`
  display: flex;
  flex-direction: column;
  margin: 3rem 0;
  padding: 0 2.5rem;
`;

export const LinLogoImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 10rem;
  margin: 1rem 0 3rem;
  border: 0;

  @media (min-width: 76.8rem) {
    margin: 4rem 0;
  }
`;

export const PolicyLetterSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-color: #fafafa;
  border: 0.1rem solid #cccdd3;
  border-radius: 1rem;

  @media (min-width: 76.8rem) {
    padding: 2.5rem;
    flex-direction: row;
  }
`;

export const PolicyLetterSectionColumn = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;

  @media (min-width: 76.8rem) {
    width: 50%;

    &:first-child {
      margin-right: 1rem;
    }

    &:nth-child(2) {
      margin-left: 1rem;
    }
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-weight: 700;
  margin-bottom: 1rem;
  padding: 0 0 1rem;
  border-bottom: 0.1rem solid #e5e5e8;

  &:last-child {
    border: 0;
  }

  @media (min-width: 76.8rem) {
    flex-direction: row;
  }
`;

export const Label = styled.div`
  min-width: 18rem;
  font-weight: 400;
`;

export const Disclaimer = styled.p`
  font-size: 1.3rem;
  color: #7b7d8c;
`;

export const PolicyContentTable = styled.table`
  width: 100%;
  text-align: left;

  td {
    font-size: 1.2rem;
    border-top: 0.1rem solid #e5e5e8;
    padding: 1rem 0;

    &:first-child {
      min-width: auto;
      white-space: nowrap;
    }

    &:nth-child(2) {
      min-width: auto;
    }

    @media (min-width: 76.8rem) {
      font-size: 1.5rem;
    }
  }

  th {
    font-size: 1.4rem;
  }
`;
